import React from 'react';

import { Button } from 'components/ui/button';
import { useTasks } from '../context/tasks_context';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons';

export function TasksNewButton() {
  const { paths, showTaskModal } = useTasks();

  if (!paths.create) return null;

  return (
    <div>
      <Button icon={faPlusCircle} label="New Task" onClick={() => showTaskModal()} />
    </div>
  );
}
